module.exports = __webpack_public_path__ + "static/media/arbitrage-logo.734d8118.svg";